import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Banner, BannerAction, BannerDescription } from '@wartek-id/banner'

import useToggleSdkContext from 'utils/useToogleSdk'
import { PeriodDialog } from 'app/KinerjaShared/components/PeriodDialog'
import { useAPIPelaksanaanSchools } from 'api/kinerja/useAPIKinerja'
import { isTodayBetweenDates } from 'utils/datetime'

type Props = {
  prevYear: number
}

export function BannerPenetapanPredikatKinerjaTahunan({ prevYear }: Props) {
  const toggles = useToggleSdkContext()
  const isToggleEnabled = toggles?.['kinerja-use-multiple-period'] ?? false

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const currentYear = prevYear + 1
  const isWithingDateRange = isTodayBetweenDates(
    new Date(`1/1/${currentYear}`),
    new Date(`1/31/${currentYear}`)
  )

  const { data } = useAPIPelaksanaanSchools({
    params: { skpYear: prevYear },
    options: {
      enabled: isWithingDateRange,
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 60 * 60 * 1000, // 1 hour
    },
  })

  const isUncompleted = data?.meta?.predikatAnnualCompleted === false
  const shouldShowBanner =
    isWithingDateRange && isToggleEnabled && isUncompleted

  if (!shouldShowBanner) return null

  return (
    <>
      <Banner
        animationDuration={300}
        onOpenStateChange={function Ga() {}}
        title={`Lakukan Penetapan Predikat Kinerja (Tahunan - ${prevYear})`}
        type="informational"
      >
        <BannerDescription className="!text-base !text-default">
          Penetapan sangat dibutuhkan oleh pegawai Anda. Mohon ganti periode ke
          tahun sebelumnya dan selesaikan sebelum 31 Januari.
        </BannerDescription>
        <BannerAction>
          <Button color="white" size="sm" onClick={() => setIsDialogOpen(true)}>
            Ganti periode
          </Button>
        </BannerAction>
      </Banner>

      <PeriodDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  )
}
